import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { WorkspaceHeader } from '@/components/WorkspaceHeader'
import { apiClient } from '@/lib/api'
import { usePlatform } from '@/hooks/usePlatform'
import { PianoRoll } from '@/components/werkshop/PianoRoll'

/**
 * Full-screen Piano Roll editor. Renders the same
 * `<PianoRoll />` component the Sequencer's Piano Roll tab
 * uses, but against the full viewport so users can spend
 * serious time on note editing.
 */
export const werkshopPianoRollToolRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/werkshop/tools/piano-roll',
  beforeLoad: async () => {
    try {
      await apiClient.get('/api/v1/auth/me')
    } catch {
      throw redirect({ to: '/login' })
    }
  },
  component: PianoRollTool,
})

function PianoRollTool() {
  const platform = usePlatform()
  return (
    <div className="min-h-[100dvh] bg-surface-base flex flex-col">
      <WorkspaceHeader title="Piano Roll" workspaceSwitcher="werkshop" />
      <main
        className={
          platform.isNative
            ? 'w-full px-3 sm:px-4 py-4 flex-1 flex flex-col gap-3'
            : 'w-full px-4 sm:px-6 py-6 flex-1 flex flex-col gap-4'
        }
      >
        <PianoRoll fullScreen />
      </main>
    </div>
  )
}
